export { ComponentLoader } from './component-loader.class';
export { ComponentLoaderFactory } from './component-loader.factory';
export { ContentRef } from './content-ref.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/utils/component-loader/index.js
// module id = ../../../../angular-bootstrap-md/utils/component-loader/index.js
// module chunks = 3